import { MetricsClientImpl } from '../clients/MetricsClient';

export const metricsClient = new MetricsClientImpl();
